import { ortto_communication_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { useQuery } from 'react-query';
import {
  orttoTransactionalCommunicationKeys,
  parseOrttoTransactionalCommunicationKey,
} from '../../cache-keys/orttoTransactionalCommunicationKeys';
import { queryFunction } from '../../query-function';

/** A customer's Ortto communication records, read once (never polled). */
export function useTransactionalCommunications(customerID: string | undefined) {
  const api = useAPI();

  return useQuery(
    orttoTransactionalCommunicationKeys.customer(customerID),
    queryFunction(
      ortto_communication_api.findOrttoCommunications(api),
      ({ queryKey }) => parseOrttoTransactionalCommunicationKey(queryKey)
    ),
    { enabled: api.token.length > 0 && !!customerID }
  );
}
